import React, { useState } from "react";
import { Card, Typography, Form, Input, Button, Divider, theme, Select, message, Upload, Avatar } from "antd";
import { MailOutlined, LockOutlined, PhoneOutlined, UserOutlined, GlobalOutlined, FlagOutlined, ArrowLeftOutlined, CameraOutlined, UploadOutlined } from "@ant-design/icons";
import api from "../services/api";
import { useNavigate } from "react-router";
import { useLanguage } from "../providers/LanguageProvider";
import RegisterForm from "src/components/register/RegisterForm";

const { Title, Text, Link } = Typography;

export default function Register() {
  const { token } = theme.useToken();
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const navigate = useNavigate();

  const containerStyle = {
    minHeight: "100svh",
    display: "grid",
    placeItems: "center",
    padding: 24,
    background:
      (token as any)?.isDark
        ? token.colorBgLayout
        : `linear-gradient(180deg, ${token.colorBgLayout} 0%, #fff 100%)`,
  };

  const cardStyle = {
    width: "100%",
    maxWidth: 520,
    borderRadius: 16,
    boxShadow:
      token.colorBgElevated === "#fff"
        ? "0 8px 30px rgba(0,0,0,0.06)"
        : "0 8px 30px rgba(0,0,0,0.25)",
  };


  return (
    <div style={containerStyle}>
      <Card style={cardStyle} bodyStyle={{ padding: 28 }}>
        {/* Profil Fotoğrafı */}
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <Avatar
            size={72}
            src={profileImageUrl}
            icon={<UserOutlined />}
            style={{
              background: token.colorPrimary,
              marginBottom: 8
            }}
          />
        </div>

        <Title level={3} style={{ textAlign: "center", marginBottom: 6, fontWeight: 700 }}>
          {t('REGISTER_TITLE')}
        </Title>
        <Text type="secondary" style={{ display: "block", textAlign: "center" }}>
          {t('REGISTER_SUBTITLE')}
        </Text>

        <RegisterForm />





      </Card>
    </div>
  );
}


